import { useTranslation } from 'react-i18next';
import { useMemo, useState } from 'react';

import { TableChartConfigDto, PitcherSingleSessionGameStatsChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import Table, { Order } from 'components/Table/Table';
import { getDisplayedColumns, tableHeaders } from 'utilities/tableHeaders';

export type PitcherSingleSessionGameStatsChartColumn = keyof PitcherSingleSessionGameStatsChartDataDto;

const PitcherSingleSessionGameStatsChart = ({
  chartData,
  isLoading,
  extraChartData,
}: ChartProps<PitcherSingleSessionGameStatsChartDataDto, TableChartConfigDto>) => {
  const { t } = useTranslation();

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] = useState<PitcherSingleSessionGameStatsChartColumn | '' | 'id'>('');

  const rows = useMemo(
    () =>
      chartData?.inningsPitched
        ? [
            {
              ...chartData,
              id: chartData.chartId,
            },
          ]
        : [],
    [chartData]
  );

  const columns = useMemo(() => {
    const displayedColumns = getDisplayedColumns<PitcherSingleSessionGameStatsChartColumn>(extraChartData.visibleStats);

    return displayedColumns.map((column) => ({
      ...tableHeaders[column],
      field: column,
      headerName: t(column),
      headerShortName: t('short.' + column),
      sortable: true,
    }));
  }, [extraChartData.visibleStats]);

  return (
    <Table
      rows={rows}
      pageState={[page, setPage]}
      orderState={[order, setOrder]}
      orderByState={[orderBy, setOrderBy]}
      columns={columns}
      loading={isLoading}
      noFooter
      tileTable
      skeletonRows={1}
    />
  );
};

export default PitcherSingleSessionGameStatsChart;
